export function assertCompleteBulkLabelPdf(failedShipmentIds: string[]) {
  if (failedShipmentIds.length === 0) return;
  throw new Error(
    `${failedShipmentIds.length} etiket PDF'i henüz hazır olmadığı için eksik toplu PDF indirilmedi. Son toplu işlemden yeniden deneyin.`
  );
}
